import React, { useEffect, useState } from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import useStyles from "./Styles";

import FooterView from "./FooterView";
import ContentView from "./ContentView";
import HeaderView from "./HeaderView";
import { bgImages, landingPrefix } from "./Constants";
import MapView from "./MapView";

const LandingView = () => {
  const classes = useStyles();
  const [bgIndex, setBG] = useState(
    Math.floor(Math.random() * Math.floor(bgImages.length))
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setBG((bgIndex + 1) % bgImages.length);
    }, 10000);
    return () => {
      clearTimeout(timer);
    };
  }, [bgIndex]);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const bgStyle = {
    backgroundImage: `url('${landingPrefix}${bgImages[bgIndex]}')`,
    transition: "background-image 2s ease-in-out",
  };
  if (!matches) {
    bgStyle["height"] = "100%";
  }
  return (
    <>
      {bgImages.map((img) => (
        <img key={img} alt="bg" width="0px" src={`${landingPrefix}${img}`} />
      ))}
      <Grid container className={classes.backpane} style={bgStyle}>
        <Grid
          item
          xs={12}
          container
          alignContent="flex-start"
          direction="row"
          className={classes.content}
        >
          <Grid
            item
            md={6}
            xs={12}
            container
            justify="flex-start"
            alignContent="space-between"
            className={classes.leftContent}
          >
            <HeaderView />
            <ContentView />
            <FooterView />
          </Grid>
          {matches && <MapView />}
        </Grid>
      </Grid>
    </>
  );
};

export default LandingView;
